<template>
  <div class="container">
    <div>
      <img v-for="(item, index) in htmlShowImgUrls" v-lazy="youpPath + item" class="poster_img" :key="index" />
    </div>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
export default {
  data () {
    return {
      haveScreen: 0,
      // 平台 --> 0：淘宝（默认）1：拼多多
      platform: 0,
      youpPath: IMG_BASE_URL,
      indexStep: 1,
      htmlShowImgUrls: [],
      // 有筛选条件
      haveScreenImgUrls: [
        '/upaiyun/Sys/20200106/4871671522140731204.gif',
        '/upaiyun/Sys/20200106/5227780995475051743.gif',
        '/upaiyun/Sys/20200106/5676295165839530667.gif'
      ],
      pddHaveScreenImgUrls: [
        '/upaiyun/Sys/20200106/4685334375732920628.png',
        '/upaiyun/Sys/20200106/5484246698402040734.png',
        '/upaiyun/Sys/20200106/5160003244620567249.png'
      ],
      jdHaveScreenImgUrls: ['/upaiyun/Sys/20211109/5160589671832663712.jpg'],
      noScreenImgUrls: [
        '/upaiyun/Sys/20200106/5148395096165042972.gif',
        '/upaiyun/Sys/20200106/5464647910002465330.jpg'
      ],
      pddNoScreenImgUrls: [
        '/upaiyun/Sys/20200106/4733453056072375265.png',
        '/upaiyun/Sys/20200106/5588580840140085560.png'
      ],
      jdNoScreenImgUrls: ['/upaiyun/Sys/20211109/5139759667130528332.jpg'],
      dyNoScreenImgUrls: ['/upaiyun/Sys/20220104/5566613451636022186.jpg'],
      // 第二步如何验证提示图
      step2ImgUrls: [
        '/upaiyun/Sys/20220222/4795579178862155826.jpg'
      ],
      pddStep2ImgUrls: [
        '/upaiyun/Sys/20220222/5521184081286178592.jpg'
      ],
      jdStep2ImgUrls: ['/upaiyun/Sys/20220222/5230305636479755068.jpg'],
      // 第三步常见问题
      step3ImgUrls: [
        '/upaiyun/Sys/20181212/5658687401457284202.png',
        '/upaiyun/Sys/20181212/5556499816533370731.png',
        '/upaiyun/Sys/20181212/4761459440156585267.png',
        '/upaiyun/Sys/20181212/4923832835577994288.png',
        '/upaiyun/Sys/20181212/5381552724296780226.png'
      ],
      step3PddImgUrls: [
        '/upaiyun/Sys/20200108/5717422979838388004.png',
        '/upaiyun/Sys/20200108/4628275441731284980.png',
        '/upaiyun/Sys/20200108/5595289071320956523.png',
        '/upaiyun/Sys/20200108/4952589596863515977.png',
        '/upaiyun/Sys/20200108/5018157618876797917.png'
      ],
      step3JdImgUrls: ['/upaiyun/Sys/20211112/5549492633229591831.jpg'],
      step3DyImgUrls: ['/upaiyun/Sys/20220104/5689356709109406840.jpg'],
      rebateImgUrls: [
        '/upaiyun/Sys/20190110/4811304971309052040.jpg',
        '/upaiyun/Sys/20190110/5401876337961689640.jpg',
        '/upaiyun/Sys/20190110/5478866504960651349.jpg'
      ]
    }
  },
  created () {
    this.indexStep = this.$route.query.indexStep
      ? parseInt(this.$route.query.indexStep)
      : 1
    if (this.$route.query.haveScreen) {
      this.haveScreen = parseInt(this.$route.query.haveScreen) || 0
    }
    if (this.$route.query.platform) {
      this.platform = parseInt(this.$route.query.platform) || 0
    }
    switch (this.indexStep) {
      case 1:
        // 淘宝/天猫（默认）1：拼多多、2：京东、3：抖音
        switch (this.platform) {
          case 2:
            // 拼多多
            if (this.haveScreen) { this.htmlShowImgUrls = this.pddHaveScreenImgUrls } else this.htmlShowImgUrls = this.pddNoScreenImgUrls
            break
          case 1:
            // 京东
            if (this.haveScreen) { this.htmlShowImgUrls = this.jdHaveScreenImgUrls } else this.htmlShowImgUrls = this.jdNoScreenImgUrls
            break
          case 3:
            // 抖音
            this.htmlShowImgUrls = this.dyNoScreenImgUrls
            break
          default:
            // 0 淘宝/天猫
            if (this.haveScreen) this.htmlShowImgUrls = this.haveScreenImgUrls
            else this.htmlShowImgUrls = this.noScreenImgUrls
            break
        }
        break
      case 2:
        // 淘宝/天猫（默认）1：拼多多、2：京东、3：抖音
        switch (this.platform) {
          case 2:
            // 拼多多
            this.htmlShowImgUrls = this.pddStep2ImgUrls
            break
          case 1:
            // 京东
            this.htmlShowImgUrls = this.jdStep2ImgUrls
            break
          default:
            // 0 淘宝/天猫
            this.htmlShowImgUrls = this.step2ImgUrls
            break
        }
        break
      case 3:
        this.$Lazyload.options.preLoad = 3
        // 淘宝/天猫（默认）1：拼多多、2：京东、3：抖音
        switch (this.platform) {
          case 2:
            // 拼多多
            this.htmlShowImgUrls = this.step3PddImgUrls
            break
          case 1:
            // 京东
            this.htmlShowImgUrls = this.step3JdImgUrls
            break
          case 3:
            // 抖音
            this.htmlShowImgUrls = this.step3DyImgUrls
            break
          default:
            // 0 淘宝/天猫
            this.htmlShowImgUrls = this.step3ImgUrls
            break
        }
        break
      case 4:
        this.htmlShowImgUrls = this.rebateImgUrls
        break
    }
  },
  beforeDestroy () {
    this.$Lazyload.options.preLoad = 1.3
  }
}
</script>

<style scoped>
.poster_img {
  width: 100%;
  display: block;
}
image[lazy="loading"] {
  width: 100%;
  margin: auto;
  background: #fff;
}
</style>
